export default __webpack_public_path__ + "static/media/notification_sound.5cacd0ed.mp3";